/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {memo} from 'react'
import {toAbsoluteUrl} from '../../../../../_metronic/helpers'
import {NotImported} from '../../../components/NotInformat'

type Props = {
  concessionaries: any[]
  onOpenMonitoring: (item: any) => void
}

const STATUS_MON_AUT_COLORS: Record<string, string> = {
  MONITORADA: 'success',
  'NÃO MONITORADA': 'danger',
  'EM MANUTENÇÃO': 'info',
}

const STATUS_EXTRACT_COLORS: Record<string, string> = {
  EXTRAI: 'success',
  'NAO EXTRAI': 'danger',
  SALVA: 'warning',
}

const TYPE_MONITOR_COLORS: Record<string, string> = {
  EMAIL: 'primary',
  CREDENCIAIS: 'info',
}

const StatusBadge = ({value, colors}: {value: string; colors: Record<string, string>}) => {
  if (!value) return <NotImported className='fs-6 text-gray-400' />

  const badgeColor = colors[value] || 'secondary'

  return (
    <span className={`badge badge-light-${badgeColor} fs-7 fw-semibold`}>
      {value}
    </span>
  )
}

export const TableBody = memo(function TableBody({concessionaries, onOpenMonitoring}: Props) {
  return (
    <tbody>
      {concessionaries && concessionaries.length > 0 ? (
        concessionaries.map((item: any) => (
          <tr key={item.id}>
            <td>
              <div className='d-flex align-items-center'>
                <div className='symbol symbol-45px me-5'>
                  <span
                    className='symbol-label'
                    style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                  >
                    <img
                      src={toAbsoluteUrl(
                        item 
                        && item.link_imagem 
                        ? item.link_imagem 
                        : 'https://res.cloudinary.com/deq3ehxe3/image/upload/v1771533247/1275576_zn46s3.png'
                      )}
                      alt='Concessionária'
                      className='svg-icon-muted'
                      style={{width: '35px', height: '35px', objectFit: 'contain'}}
                    />
                  </span>
                </div>
                <div className='d-flex justify-content-start flex-column'>
                  <span className='text-dark fw-bold fs-6'>
                    {item.name || <NotImported className='fs-6 text-gray-400' />}
                  </span>
                  {item.sub_name && (
                    <span className='text-muted fw-semibold d-block fs-7'>{item.sub_name}</span>
                  )}
                </div>
              </div>
            </td>

            <td>
              <StatusBadge value={item.status_mon_aut} colors={STATUS_MON_AUT_COLORS} />
            </td>

            <td>
              <StatusBadge value={item.status_extract} colors={STATUS_EXTRACT_COLORS} />
            </td>

            <td>
              <StatusBadge value={item.type_monitor} colors={TYPE_MONITOR_COLORS} />
            </td>

            <td>
              <div className='d-flex justify-content-end flex-shrink-0'>
                <button
                  type='button'
                  onClick={(event) => {
                    event.stopPropagation()
                    onOpenMonitoring(item)
                  }}
                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                  title='Editar monitoramento das unidades consumidoras'
                >
                  <i className='bi bi-pencil-fill' style={{fontSize: '1.2rem'}}></i>
                </button>
              </div>
            </td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan={5} className='text-center py-10'>
            <span className='text-muted fw-semibold fs-5'>Nenhuma concessionária encontrada!</span>
          </td>
        </tr>
      )}
    </tbody>
  )
})
